import { render, staticRenderFns } from "./DVS.vue?vue&type=template&id=16abe3b7"
import script from "./DVS.vue?vue&type=script&lang=js"
export * from "./DVS.vue?vue&type=script&lang=js"
import style0 from "./DVS.vue?vue&type=style&index=0&id=16abe3b7&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports